import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import { Parallax } from "react-scroll-parallax";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    phonenumber: "",
  });

  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_0kjf49c", // Replace with your EmailJS service ID
        "template_b2uw7oc", // Replace with your EmailJS template ID
        e.target,
        "xNpFKnNz6VDgopweY" // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          console.log(result.text);
          setModal({
            isOpen: true,
            title: "Success",
            message: "Message sent successfully!",
          });
        },
        (error) => {
          console.log(error.text);
          setModal({
            isOpen: true,
            title: "Error",
            message: "Error sending message, please try again.",
          });
        }
      );
  };
  const closeModal = () => {
    setModal({ isOpen: false, title: "", message: "" });
  };

  return (
    <div className="relative">
      {/* Full-width Map */}
      {modal.isOpen && (
        <div className="fixed inset-0 bg-black  bg-opacity-80 rounded flex justify-center items-center z-20">
          <div className="bg-black border-yellow-700 border-2 rounded-lg shadow-lg p-6 w-96">
            <h2 className="text-xl text-gray-200 font-bold mb-4">{modal.title}</h2>
            <p className="text-gray-300 mb-6">{modal.message}</p>
            <div className="text-center">
              <button
                onClick={closeModal}
                className="bg-yellow-600 border-2 hover:scale-110 active:scale-90 border-yellow-600 text-white py-2 px-4 rounded hover:bg-transparent transition duration-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        {/* <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: "url('../img5.jpg')",
                  height: "100vh",
                }}
              >
                {/* Overlay to darken background *
                <div className="absolute inset-0 bg-black opacity-50"></div>
              </div>
         */}
              {/* Main Content */}
              {/* <div className="relative  text-white">
                {/* Parallax Heading 
                
                  <div className="flex justify-center items-center h-screen text-center px-6">
                  <Parallax translateY={[-150,200]}>
                    <p className="text-gray-300 text-2xl font-serif">Let's Talk</p>
                    <motion.h1
                      className="text-4xl md:text-7xl font-extrabold font-serif uppercase tracking-wide leading-tight"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 1 }}
                    >
                     Contact us
                    </motion.h1>
                    </Parallax>
                  </div>
        </div> */}
      {/* <div className="w-full h-96">
        <iframe
          className="w-full h-full rounded"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d237.9403589569681!2d78.54373823776152!3d17.409592275515298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDI0JzM0LjkiTiA3OMKwMzInMzguMCJF!5e0!3m2!1sen!2sin!4v1736933919155!5m2!1sen!2sin"
          title="Google Map"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div> */}

      {/* Contact Section */}
      <div className="container mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Section: Office Details */}
          <div className="">
            <motion.h2
              className="text-4xl font-semibold font-serif text-yellow-600 mb-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              Contact Information
            </motion.h2>

            {/* Registered Office */}
            {/* <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-300">Registered Office</h3>
              <p className="text-gray-400">H.No: 1-5-24/1, Plot No:89, Brindavan Nagar, Habsiguda, Hyderabad.</p>
            </div>

            {/* Corporate Office 
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-300">Corporate Office</h3>
              <p className="text-gray-400">H.No: 1-5-24/1, Plot No:89, Brindavan Nagar, Habsiguda, Hyderabad.</p>
            </div>

            {/* Contact Details 
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-300">Contact</h3>
              <p className="text-gray-400">Phone: +91 9030982315</p>
              <p className="text-gray-400">Email: info@tnrtechnologies.co.in</p>
            </div>

            {/* Social Media Links 
            <div className="flex space-x-6">
              <a
                href="https://www.facebook.com/profile.php?id=61571723499720"
                className="text-gray-400 hover:text-red-600 transition"
                target="blank"
              >
                Facebook
              </a>
              <a
                href="https://youtube.com/@tnr.technologies?si=tB4UZoE753BjpE_F"
                className="text-gray-400 hover:text-red-600 transition"
                target="blank"
              >
                Youtube
              </a>
              <a
                href="https://www.instagram.com/tnr.technologies?utm_source=qr&igsh=bnQyMjF5aHppNHV5"
                className="text-gray-400 hover:text-red-600 transition"
                target="blank"
              >
                Instagram
              </a>
              <a
                href="https://www.linkedin.com/company/tnr-technologies?trk=blended-typeahead"
                className="text-gray-400 hover:text-red-600 transition"
                target="blank"
              >
                LinkedIn
              </a>
            </div> */}
            <iframe
          className="w-full h-full rounded"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3805.5297756760656!2d78.4113349751671!3d17.482206283421238!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTfCsDI4JzU1LjkiTiA3OMKwMjQnNTAuMSJF!5e0!3m2!1sen!2sin!4v1744197221501!5m2!1sen!2sin"
          title="Google Map"
          style={{ border: "0" }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
          </div>

          {/* Right Section: Contact Form */}
          <div className="my-8">
            <motion.h2
              className="text-4xl font-semibold font-serif text-yellow-600 my-8"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            >
              Get in Touch
            </motion.h2>

            <motion.form
              onSubmit={handleSubmit}
              className="bg-white h-full flex flex-col content-center p-8 border-2 border-gray-300 rounded shadow-lg"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              name="contact-form"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label
                    htmlFor="name"
                    className="text-lg font-semibold text-gray-700 mb-2"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full p-3 rounded bg-gwhite border-2 border-gray-300 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-600"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="text-lg font-semibold text-gray-700 mb-2"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full p-3 rounded bg-white border-2 border-gray-300 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-600"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mt-6">
                  <label
                    htmlFor="phonenumber"
                    className="text-lg font-semibold text-gray-700 mb-2"
                  >
                    Phone Number
                  </label>
                  <input
                    type="phonenumber"
                    id="phonenumber"
                    name="phonenumber"
                    className="w-full p-3 rounded bg-white  border-2 border-gray-300 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-600"
                    placeholder="Enter your email"
                    value={formData.phonenumber}
                    onChange={handleChange}
                  />
                </div>
              <div className="mt-6">
                <label
                  htmlFor="message"
                  className="text-lg font-semibold text-gray-700 mb-2"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  className="w-full p-3 rounded bg-white  border-2 border-gray-300 text-black placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-600"
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="mt-6 text-center">
                <button
                  type="submit"
                  className="bg-yellow-600 border-2 hover:scale-110 active:scale-90 border-yellow-600 text-black py-3 px-8 rounded hover:bg-transparent transition duration-300"
                >
                  Send Message
                </button>
              </div>
            </motion.form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;


